import { render, staticRenderFns } from "./merge-contacts-modal.vue?vue&type=template&id=14dc7f47&"
import script from "./merge-contacts-modal.vue?vue&type=script&lang=ts&"
export * from "./merge-contacts-modal.vue?vue&type=script&lang=ts&"
import style0 from "./merge-contacts-modal.vue?vue&type=style&index=0&_scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports